import React from 'react'
import { Button } from 'antd';

export const ButtonsFormComments = ({
    isOvertimeComments,
    actionOverTime,
    loading,
    backTab,
    nextTab,
    selectIteamTab,
    isDisableBackButton = true,
    children
}) => {
    return (
        <div className="w-full h-full mt-4 flex flex-col gap-4" >
            <div className='flex justify-end gap-4'>
                {isOvertimeComments && (
                    <Button type="primary" onClick={actionOverTime} className={`text-[10px]`}>
                        Análisis en rojo
                    </Button>
                )}
                <Button disabled={isDisableBackButton} loading={loading} onClick={backTab} className={`${selectIteamTab && 'hidden'} text-[10px]`}>
                    Atrás
                </Button>
                <Button type='primary' htmlType="submit" loading={loading} onClick={nextTab} className={`bg-primaryTwo hover:bg-primaryTwoHover text-white text-[10px]`} >
                    {children}
                </Button>
            </div>
        </div>
    )
}
